import cancelImage from "../../assets/images/cancel.png";
import {
  useDeleteTodoMutation,
  useUpdateTodoMutation
} from "../../features/todoApi/todoApiSlice";
import TodoSkeleton from "../ui/loaders/TodoSkeleton";

export default function CompleteTodoCard({ todo }) {
  const { text, id, completed, color } = todo;
  const [updateTodo, { isLoading: updateIsLoading }] = useUpdateTodoMutation();
  const [deleteTodo, { isLoading: deleteIsLoading }] = useDeleteTodoMutation();

  const handleStatusChange = (todoId) => {
    updateTodo({
      id: todoId,
      data: { completed: false },
      complete: false,
      RefetchAllTodos: true,
    });
  };

  const handleDelete = (todoId) => {
    deleteTodo({ id: todoId, complete: true });
  };

  return (
    <>
      {deleteIsLoading || updateIsLoading ? (
        <TodoSkeleton />
      ) : (
        <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
          <div
            className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 cursor-pointer ${
              completed && "border-green-500 focus-within:border-green-500"
            }`}
          >
            <input
              type="checkbox"
              checked={completed}
              onChange={() => handleStatusChange(id)}
              className="opacity-0 absolute rounded-full cursor-pointer"
            />
            {completed && (
              <svg
                className="fill-current w-3 h-3 text-green-500 pointer-events-none cursor-pointer"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            )}
          </div>
          <div className="select-none flex-1">{text}</div>
          <div
            className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto hover:bg-${color}-500 border-${color}-500 bg-${color}-500`}
          ></div>

          <img
            src={cancelImage}
            className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
            alt="Cancel"
            onClick={() => handleDelete(id)}
          />
        </div>
      )}
    </>
  );
}
